import { Alert } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React, { useState } from "react";
import { useVoiceAccount } from "../../hooks/useVoiceAccount";

export const DisconnectVoiceAccountAlert: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
}> = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslations();
  const { account, disconnectAccount } = useVoiceAccount();
  const [isConfirmed, setIsConfirmed] = useState(false);

  const phoneNumber = account?.phone_num ?? "";

  const handleRequestClose = () => {
    setIsConfirmed(false);
    onRequestClose();
  };

  return (
    <Alert
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      textAlignment="left"
      title={t({
        id: "client-support-page.disconnect-account-warning-title",
        defaultMessage: "⚠️ Disconnect Account",
      })}
      content={t(
        {
          id: "client-support-page.disconnect-voice-account-confirmation",
          defaultMessage:
            "You're about to disconnect the phone number {phoneNumber} associated to your Workspace. Phone number will be removed and no longer active. This action cant be undone",
        },
        {
          phoneNumber: (
            <span className="font-medium text-primary">{phoneNumber}</span>
          ),
        }
      )}
      skipFutureAlerts={{
        label: t({
          id: "common.i-understand-and-confirm-the-action",
          defaultMessage: "I understand and confirm the action",
        }),
        containerClassName: "justify-start",
        onChange: setIsConfirmed,
      }}
      buttons={[
        {
          text: t({
            id: "common.cancel",
            defaultMessage: "Cancel",
          }),
          color: "grey",
          role: "close",
        },
        {
          text: t({
            id: "client-support-page.disconnect",
            defaultMessage: "Disconnect",
          }),
          color: "tertiary",
          isDisabled: !isConfirmed,
          onClick: async (_, { closeAlert }) => {
            closeAlert();
            await disconnectAccount();
          },
        },
      ]}
    />
  );
};
